import { useState } from "react";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import Card from "react-bootstrap/Card";
import "./App.css";
import Project1 from "./project1";
import Project2 from "./project2";
import Project3 from "./project3";
import Project4 from "./project4";
import Project5 from "./project5";
import Project6 from "./project6";
import Project7 from "./project7";
import Project8 from "./project8";
import CICD from "./images/CICD.drawio.png";
import C from "./images/C.png";
import aws from "./images/aws.png";
import kub from "./images/kubernetes.png";
import git from "./images/Git.png";
import docker from "./images/docker.png";
import flask from "./images/flaskB.jpg";
import C_plus from "./images/C++.png";
import x86 from "./images/x86.png";
import Riscv from "./images/Riscv.jpg";
import node from "./images/node.png";
import Rt from "./images/React.png";
import jquery from "./images/jquery.png";
import bootstrap from "./images/bootstrap.svg";
import React from "react";

function App() {
  const [p1, setP1] = useState(false);
  const [p2, setP2] = useState(false);
  const [p3, setP3] = useState(false);
  const [p4, setP4] = useState(false);
  const [p5, setP5] = useState(false);
  const [p6, setP6] = useState(false);
  const [p7, setP7] = useState(false);
  const [p8, setP8] = useState(false);
  const callAPI = () => {
    setP1(true);
  };
  const callP2 = () => {
    setP2(true);
  };
  const callP3 = () => {
    setP3(true);
  };
  const callP4 = () => {
    setP4(true);
  };
  const callP5 = () => {
    setP5(true);
  };
  const callP6 = () => {
    setP6(true);
  };
  const callP7 = () => {
    setP7(true);
  };
  const callP8 = () => {
    setP8(true);
  };
  let content;

  if (!p1) {
    if (!p2) {
      if (!p3) {
        if (!p4) {
          if (!p5) {
            if (!p6) {
              if (!p7) {
                if (!p8) {
                  content = (
                    <div className="body">
                      <br />
                      <h3 className="Name">Akhileshwar Shriram</h3>
                      <br />
                      <div className="Name">Thank you for reviewing my resume. I have implemented a Continuous Integration/Continuous Deployment (CI/CD)</div>
                      <div className="Name">system to ensure that users always have access to the latest version of my resume.</div> 
                     
                      <br />
                      <div className="title">
                        <h4>Key Highlights</h4>
                        <div>
                          Excellent problem-solving abilities and curious to learn.
                        </div>
                        <div>
                          Effective communicator and a team player.
                        </div>
                        <div>
                          Interested to dive deep in complex projects and establish trust.
                        </div>
                        <div>
                          Enthusiastic about staying up-to-date with emerging
                          technologies and industry trends.
                        </div>
                      </div>
                      <div className="Connect">
                        <a
                          href="https://github.com/AkhilTheBoss"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Button variant="secondary">Github</Button>
                        </a>
                        <a
                          href="https://www.linkedin.com/in/akhileshwar-shriram-25aa51253/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Button variant="primary">Linkedin</Button>
                        </a>
                      </div>
                      <br />
                      <br />
                      <div className="Topics">
                        <h4 className="title">My Skills</h4>
                        <br />
                        <br />
                        <h5 className="title">Familiar Programming Languages</h5>
                        <div class="row">
                          <div class="column">
                            <img
                              src="https://cdn.ahnafzamil.com/website-back/experience/python.png"
                              alt="Python"
                              style={{ width: "5rem", height: "5rem" }}
                            />
                            <div>Python</div>
                          </div>
                          <div class="column">
                            <img
                              src="https://cdn.ahnafzamil.com/website-back/experience/javascript.png"
                              alt="JavaScript"
                              style={{ width: "5rem", height: "5rem" }}
                            />
                            <div>JavaScript</div>
                          </div>
                          <div class="column">
                            <img
                              src={C}
                              alt="JavaScript"
                              style={{ width: "5rem", height: "5rem" }}
                            />
                            <div>C</div>
                          </div>
                          <div class="column">
                            <img
                              src={C_plus}
                              alt="JavaScript"
                              style={{ width: "5rem", height: "5rem" }}
                            />
                            <div>C++</div>
                          </div>
                        </div>
                        <br />
                        <br />
                        <h5 className="title">Familiar Frameworks & Libraries</h5>
                        <div class="row">
                          <div class="column">
                            <img
                              src={Rt}
                              alt="Python"
                              style={{ width: "5rem", height: "5rem" }}
                            />
                            <div>React</div>
                          </div>
                          <div class="column">
                            <img
                              src={node}
                              alt="Python"
                              style={{ width: "5rem", height: "5rem" }}
                            />
                            <div>Node</div>
                          </div>
                          <div class="column">
                            <img
                              src={flask}
                              alt="Python"
                              style={{ width: "5rem", height: "5rem" }}
                            />
                            <div>Flask</div>
                          </div>
                          <div class="column">
                            <img
                              src={bootstrap}
                              alt="Python"
                              style={{ width: "5rem", height: "5rem" }}
                            />
                            <div>Bootstrap</div>
                          </div>
                        </div>
                        <br />
                        <br />
                        <h5 className="title">Familiar DevOps & Cloud</h5>
                        <div class="row">
                          <div class="column">
                            <img
                              src={git}
                              alt="Git"
                              style={{ width: "5rem", height: "5rem" }}
                            />
                            <div>Git</div>
                          </div>
                          <div class="column">
                            <img
                              src={docker}
                              alt="Python"
                              style={{ width: "5rem", height: "5rem" }}
                            />
                            <div>Docker</div>
                          </div>
                          <div class="column">
                            <img
                              src={kub}
                              alt="Python"
                              style={{ width: "5rem", height: "5rem" }}
                            />
                            <div>Kubernetes</div>
                          </div>
                          <div class="column">
                            <img
                              src={aws}
                              alt="Python"
                              style={{ width: "5rem", height: "5rem" }}
                            />
                            <div>Amazon Web Services</div>
                          </div>
                        </div>
                      </div>
                      <h4 className="About">How I deployed my resume?</h4>
                      <p>
                        <img src={CICD} alt="CICD1" className="Diagramx" />
                      </p>
                      <div class="center-content">
                        <p id="deploydescribe">
                          AWS CodePipeline is a fully managed continuous
                          integration and continuous delivery (CI/CD) service.
                          It automates the steps in your CI/CD workflow from
                          source code integration to deployment. CodePipeline
                          allows you to define stages that make up your
                          pipeline(eg: source, build, deploy stages).
                          <br />
                          <div>My CodePipeline has three stages:</div>
                          <ul>
                            <li>Source Stage:</li> The Source stage is the first
                            stage in a CodePipeline. It is responsible for
                            fetching the source code of your application from a
                            source code repository. AWS CodeCommit is the source
                            code repository I used.
                            <li>Build Stage:</li> The Build stage is where you
                            compile, test, and package your source code into a
                            deployable artifact. Artifact are files generated
                            during the build stage of a CI/CD pipeline. These
                            artifacts represent the compiled and tested code
                            that is ready for deployment to a target
                            environment. I used AWS CodeBuild for the build
                            stage.
                            <li>Deploy Stage:</li> The Deploy stage is where the
                            build artifacts created in the previous stage are
                            deployed to a target environment. I used AWS
                            CodeDeploy as it simplifies and automates the
                            deployment of applications to a variety of compute
                            service. For our application, the compute service
                            was an S3 bucket for static hosting.
                          </ul>
                        </p>
                      </div>
                      <h4 className="About">My Projects</h4>
                      <div className="cards">
                        <div id="card1">
                          <Card style={{ width: "18rem" }}>
                            <Card.Body>
                              <Card.Title>Demand Paging Simulator</Card.Title>
                              <Card.Text>
                                Created a simulator to simulate and analyze the
                                behavior of a demand paging service in an
                                operating system.
                              </Card.Text>
                              <Button variant="success" onClick={callAPI}>
                                Detailed Project Description
                              </Button>
                            </Card.Body>
                          </Card>
                        </div>
                        <div id="card2">
                          <Card style={{ width: "18rem" }}>
                            <Card.Body>
                              <Card.Title>
                                Language Translation Application
                              </Card.Title>
                              <Card.Text>
                                Created an application that converts spoken
                                speech into its appropriate translation text and
                                vocalizes the translated output.
                              </Card.Text>
                              <Button variant="success" onClick={callP2}>
                                Detailed Project Description
                              </Button>
                            </Card.Body>
                          </Card>
                        </div>
                        <div id="card3">
                          <Card style={{ width: "18rem" }}>
                            <Card.Body>
                              <Card.Title>
                                Image Filtering And Edge Detection
                              </Card.Title>
                              <Card.Text>
                                The purpose of this project is to explore
                                different image processing techniques.
                              </Card.Text>
                              <Button variant="success" onClick={callP3}>
                                Detailed Project Description
                              </Button>
                            </Card.Body>
                          </Card>
                        </div>
                        <div id="card4">
                          <Card style={{ width: "18rem" }}>
                            <Card.Body>
                              <Card.Title>Shell</Card.Title>
                              <Card.Text>
                                Created a command-line interpreter that accepts
                                commands from the user and executes them.
                              </Card.Text>
                              <Button variant="success" onClick={callP4}>
                                Detailed Project Description
                              </Button>
                            </Card.Body>
                          </Card>
                        </div>
                        <div id="card5">
                          <Card style={{ width: "18rem" }}>
                            <Card.Body>
                              <Card.Title>
                                Real-Time Chat Application
                              </Card.Title>
                              <Card.Text>
                                Created a web application where multiple users
                                can group chat in chosen groups.
                              </Card.Text>
                              <Button variant="success" onClick={callP5}>
                                Detailed Project Description
                              </Button>
                            </Card.Body>
                          </Card>
                        </div>
                        <div id="card5">
                          <Card style={{ width: "18rem" }}>
                            <Card.Body>
                              <Card.Title>Spotify Stats</Card.Title>
                              <Card.Text>
                                Created a web application where multiple users
                                can group chat in chosen groups.
                              </Card.Text>
                              <Button variant="success" onClick={callP6}>
                                Detailed Project Description
                              </Button>
                            </Card.Body>
                          </Card>
                        </div>
                        <div id="card5">
                          <Card style={{ width: "18rem" }}>
                            <Card.Body>
                              <Card.Title>
                                FISC Assembler and Simulator
                              </Card.Title>
                              <Card.Text>
                                Created an Assembler that converts FISC assembly
                                code into hexadecimal values and created a
                                simulator that converts hexadecimal values and
                                displays the execution of the program line by
                                line.
                              </Card.Text>
                              <Button variant="success" onClick={callP7}>
                                Detailed Project Description
                              </Button>
                            </Card.Body>
                          </Card>
                        </div>
                        <div id="card5">
                          <Card style={{ width: "18rem" }}>
                            <Card.Body>
                              <Card.Title>A* Pathfinding Visualizer</Card.Title>
                              <Card.Text>
                                Created a web application where multiple users
                                can group chat in chosen groups.
                              </Card.Text>
                              <Button variant="success" onClick={callP8}>
                                Detailed Project Description
                              </Button>
                            </Card.Body>
                          </Card>
                        </div>
                      </div>
                    </div>
                  );
                } else {
                  content = <Project8 />;
                }
              } else {
                content = <Project7 />;
              }
            } else {
              content = <Project6 />;
            }
          } else {
            content = <Project5 />;
          }
        } else {
          content = <Project4 />;
        }
      } else {
        content = <Project3 />;
      }
    } else {
      content = <Project2 />;
    }
  } else {
    content = <Project1 />;
  }

  return <div className="App">{content}</div>;
}

export default App;
